import React from "react";
import { Sparkles, Wallet, Network, Headphones } from "lucide-react";

const items = [
  {
    title: "100% sur mesure",
    desc: "Chaque projet est unique. Matériaux, dimensions, finitions — tout est conçu pour vous.",
    icon: Sparkles,
  },
  {
    title: "Budget maîtrisé",
    desc: "Mise en concurrence intelligente entre fabricants pour le meilleur rapport qualité-prix.",
    icon: Wallet,
  },
  {
    title: "Réseau de fabricants",
    desc: "Un carnet d'adresses d'artisans locaux et nationaux soigneusement sélectionnés.",
    icon: Network,
  },
  {
    title: "Un seul interlocuteur",
    desc: "Je centralise et coordonne. Vous gagnez du temps, vous gardez la sérénité.",
    icon: Headphones,
  },
];

export default function WhyMe() {
  return (
    <section
      data-testid="whyme-section"
      className="bg-stone-50 py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-14 grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <p className="mb-4 text-xs uppercase tracking-[0.25em] text-orange-800">
              Pourquoi me choisir
            </p>
            <h2 className="text-3xl font-light leading-tight tracking-tight text-stone-900 sm:text-5xl">
              Un courtier dédié à votre projet,
              <br />
              <span className="italic">pas un revendeur.</span>
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7">
            <p className="text-base leading-relaxed text-stone-600">
              Mon métier&nbsp;: vous représenter, négocier, et faire fabriquer
              exactement ce qui correspond à votre vie et à vos espaces.
              Indépendant, je travaille dans votre intérêt — pas celui d'une marque.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((it) => {
            const Icon = it.icon;
            return (
              <div
                key={it.title}
                data-testid={`whyme-${it.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="card-hover rounded-2xl border border-stone-200 bg-white p-7"
              >
                <div className="mb-6 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-orange-50 text-orange-800">
                  <Icon className="h-5 w-5" strokeWidth={1.5} />
                </div>
                <h3 className="text-lg font-medium text-stone-900">{it.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-stone-600">{it.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
